import React, { useEffect, useState } from "react";

import Drawer from "../../components/ui/Drawer";
import WalletService from "../../api/wallet-service";
import { WALLET_API_URL } from "../../api/urlMetaData";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import Table from "../../components/ui/table/table";

import { formatAmount, getAmountWithCurrency } from "../../utils/utils";
import { useLocale } from "../../hooks/useLocale";

const FeesLimitDrawer = ({ title, onClose }) => {
  const currentUser = useSelector((s) => s.auth.currentUser);
  const [loading, setLoading] = useState(false);
  const { localize } = useLocale(["cards"]);

  const [list, setList] = useState([]);

  useEffect(() => {
    fetchFeeLimit(currentUser);
  }, []);

  const fetchFeeLimit = async (currentUser) => {
    setLoading(true);
    try {
      const res = await WalletService.post(
        `${WALLET_API_URL.FEES_LIMIT_LIST}`,
        {
          userType: currentUser.productType,
          clientHashId: currentUser.clientHashId,
        }
      );
      if (res.data) {
        const { body } = res?.data;
        if (body.length) setList(body);
        setLoading(false);
      }
    } catch (error) {
      const { status, message } = error.response.data;

      if (status === "INTERNAL_SERVER_ERROR") {
        onClose();
      }
      toast(message, {
        type: "error",
      });

      setLoading(false);
    }
  };

  return (
    <>
      <Drawer title={title} onClose={onClose} width={500}>
        <>
          <Table
            loading={loading}
            cols={localize("fees.table.cols", { returnObjects: true })}
            dataSize={list.length}
          >
            <>
              {list.map((item, index) => {
                return (
                  <>
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.feeName}</td>
                      <td>
                        {getAmountWithCurrency(
                          formatAmount(item.feeValue),
                          item.currency?.curSymbol || item.currency?.localCode
                        )}
                      </td>
                    </tr>
                  </>
                );
              })}
            </>
            {/* show empty list */}
          </Table>
        </>
      </Drawer>
    </>
  );
};

export default FeesLimitDrawer;
